module.exports = __webpack_public_path__ + "static/media/15.73fd05c3.JPG";